module.exports = __webpack_public_path__ + "img/Jamaica.fe4f5fb8.svg";